import { styled, Drawer as MuiDrawer, Typography as MuiTypography } from '@mui/material';
import { includes } from 'ramda';
import { drawerMiniWidth, drawerWidth, boxShadow, defaultFont, menuBkColor, menuBkOpacity, menuColor, transition } from 'assets/jss/styles';
import { sidebarWrapperHeight } from 'constants/sidebar';

export const SidebarRef = styled('div', {
  shouldForwardProp: prop => !includes(prop, ['drawerOpen'])
})(({ drawerOpen }) => ({
  position: 'relative',
  height: sidebarWrapperHeight,
  overflow: 'none',
  width: '260px',
  zIndex: '4',
  overflowScrolling: 'touch',
  transitionProperty: 'top, bottom, width',
  transitionDuration: '.2s, .2s, .35s',
  transitionTimingFunction: 'linear, linear, ease',
  color: 'inherit',
  ...(!drawerOpen && {
    overflow: 'none',
    width: drawerMiniWidth + 'px!important'
  })
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => !includes(prop, ['drawerOpen'])
})(({ theme, drawerOpen }) => ({
  [`& .MuiDrawer-paper`]: {
    border: 'none',
    position: 'fixed',
    top: '0',
    bottom: '0',
    left: '0',
    zIndex: '1032',
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    overflowY: 'unset',
    ...boxShadow,
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      position: 'fixed',
      height: '100%'
    },
    [theme.breakpoints.down('md')]: {
      width: drawerWidth,
      ...boxShadow,
      position: 'fixed',
      top: '0',
      height: '100vh',
      right: '0',
      left: 'auto',
      zIndex: '1032',
      visibility: 'visible',
      overflowY: 'visible',
      borderTop: 'none',
      textAlign: 'left',
      paddingRight: '0px',
      paddingLeft: '0',
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition
    },
    '&:before,&:after': {
      position: 'absolute',
      zIndex: '3',
      width: '100%',
      height: '100%',
      content: '""',
      display: 'block',
      top: '0'
    },
    ...(!drawerOpen && {
      overflow: 'none',
      width: drawerMiniWidth + 'px!important'
    }),
    color: menuColor(theme),
    '&:after': {
      background: menuBkColor(theme),
      opacity: menuBkOpacity(theme)
    }
  }
}));

export const StyledLogo = styled('div')(({ theme }) => ({
  padding: '15px 0px 30px 0',
  margin: '0',
  display: 'block',
  position: 'relative',
  zIndex: '4',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '0',
    height: '1px',
    right: '15px',
    width: 'calc(100% - 30px)',
    backgroundColor: theme.palette.primary.main
  }
}));

export const StyledLogoMini = styled('a')(() => ({
  transition: 'all 300ms linear',
  opacity: 1,
  maxHeight: '30px',
  marginTop: '7px',
  color: 'inherit'
}));

export const StyledImage = styled('img')(() => ({
  width: '100%',
  verticalAlign: 'middle',
  paddingRight: '10px',
  paddingLeft: '10px',
  border: '0'
}));

export const StyledLogoDefault = styled('a', {
  shouldForwardProp: prop => !includes(prop, ['drawerOpen'])
})(({ theme, drawerOpen }) => ({
  ...defaultFont(theme),
  transition: 'all 300ms linear',
  display: 'block',
  opacity: '1',
  transform: 'translate3d(0px, 0, 0)',
  textTransform: 'uppercase',
  padding: '5px 0px',
  fontSize: '18px',
  whiteSpace: 'nowrap',
  fontWeight: '400',
  lineHeight: '30px',
  overflow: 'hidden',
  '&,&:hover,&:focus': {
    color: 'inherit'
  },
  ...(!drawerOpen && {
    opacity: '0',
    transform: 'translate3d(-25px, 0, 0)'
  })
}));

export const Typography = styled(MuiTypography)(({ theme }) => ({
  ...defaultFont(theme),
  padding: '0px 10px',
  margin: '0',
  display: 'block',
  zIndex: '4'
}));
